import Head from "next/head";
import { createHomeSearchActionSchema } from "src/constants/structured-data";
import { useRouterLocale } from "src/utils/router/use-router-locale";

export const HomeSearchActionSchema = () => {
    const { language, country } = useRouterLocale();

    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(createHomeSearchActionSchema(language, country)) }}
            />
        </Head>
    );
};
